/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOpexDto } from '../../models/backend-opex-dto';
import { BackendPatchedOpexRequestDto } from '../../models/backend-patched-opex-request-dto';

export interface SalesOpexsPartialUpdate$FormData$Params {
  /**
   * A unique integer value identifying this opex.
   */
  id: number;
  body?: BackendPatchedOpexRequestDto;
}

export function salesOpexsPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: SalesOpexsPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOpexDto>> {
  const rb = new RequestBuilder(rootUrl, salesOpexsPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOpexDto>;
    }),
  );
}

salesOpexsPartialUpdate$FormData.PATH = '/api/sales/opexs/{id}/';
